module.exports = __webpack_public_path__ + "img/b_07.3d84efdd.png";